'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoSocialSass = function IoSocialSass(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm40 25.7v0.6c-0.1 0.7-0.5 1.4-1.2 1.7s-0.9 0.4-1 0.3 0.1-0.3 0.3-0.4c1-0.6 1.4-1.6 0.8-2.6-0.4-0.8-1.2-1.2-2-1.5-1.9-0.7-3.8-0.6-5.6 0 0.3 0.9 0.5 1.7-0.2 2.6-0.8 0.9-1.8 1.5-3.1 1.7-0.5 0.2-1-0.1-1.1-0.7-0.3-1.5 1.3-2.8 2.3-3.6-0.5-0.9-0.8-1.9-1.1-2.9-1.1 1.3-2.4 3.1-2 4.7 0.2 1.1-0.1 2.1-1.1 2.8s-2.3 1.1-3.6 0.9c-0.3-0.1-0.5-0.4-0.4-0.6 0.2-1.1 2-2.5 2.7-3.4 0.2-0.1 0.3-0.3 0.1-0.5-0.4-1-0.8-1.8-1.1-2.8-1 2.2-2.3 6.2-4.4 7.6-0.7 0.5-1.3 0.3-1.7-0.4-0.2-0.6-0.1-1.5 0-2.2-0.5 1-0.9 2.1-1.6 2.9-0.6 0.6-1.9 0.6-2.3-0.1-1.3-1.6-1.1-3.9-0.4-5.7l-2.3 1.2c0.5 1.3 0.6 2.5 0.3 3.8-0.4 1.5-1.3 2.8-2.7 3.6-1.5 1-5 1.9-6-0.3-0.6-1.2-0.4-2.3 0.4-3.4 1.4-1.9 3.8-2.9 5.8-3.9-2.5-1.8-6.2-3.3-7.5-6.3-1.2-2.7 1.3-5.3 3.4-6.9 4.6-3.8 12.9-7.4 19-4.6 1.2 0.5 2.8 1.8 2.5 4-0.4 1.9-1.1 3.1-2.2 4.2-2.5 2.5-11.9 6.1-13.8 1.2-0.1-0.1-0.1-0.3 0.1-0.3 0.1 0.1 1.6 1.2 3.4 1.3 1.3 0 2.8-0.3 4-0.7 2.6-0.8 5.6-2.5 6.3-5.2 0.3-1-0.2-2.2-1.2-2.7-3.8-1.8-9.1 0.4-12.4 2.1-2.6 1.3-6.6 3.5-6.4 6.8 0 2.9 4.3 4.7 6.3 6.4 1.2-0.6 3.3-1.2 4.1-2.1 0.8-1 2-2 3.4-2.1 0.6 0 1.1 0.3 1.2 0.8 0.2 0.5 0.1 0.9 0 1.5 0.4-0.3 0.9-0.3 1.2 0.1 1 1.1-1.7 3.9-0.8 5.1 1.1-1.1 1.7-3.2 2.4-4.6 0.3-0.6 1.3-4 2-4.1 0.6-0.2 1.4-0.3 2 0 0.1 0.1 0.2 0.2 0.1 0.4-0.5 1.5-0.5 2.6 0.3 4 1-1.5 2.2-3.3 2.6-5.2 0.1-0.2 0.2-0.2 0.4-0.3 0.5-0.2 1.4-0.2 2 0 0.2 0.1 0.2 0.1 0.1 0.4-0.5 1.7-0.5 3 0.5 4.5 2.4-0.8 5.4-1.2 7.6 0.4-0.3-0.2-0.6-0.4 0 0 0.3 0.3 0.2 0.2 0 0 0.9 0.6 1.4 1.4 1.6 2.5z m-31.2 2c0.1-0.6 0-1.1-0.2-1.6-1.9 0.6-5.2 2.7-5 4.8 0.1 0.8 0.6 1.1 1.3 1s1.5-0.6 2.1-1c1.1-0.9 1.8-1.9 1.8-3.2z m8.1-5.7c0.1-0.2-0.2-0.4-0.4-0.3-2.3 0.6-3.4 4.5-2.6 6.3 0.1 0.3 0.3 0.3 0.5 0.1 1.3-1.2 2.2-4.4 2.5-6.1z m5.4 6.4c0.7 0.3 2.2-1.3 2.1-2.1-0.6 0.7-1.4 1.4-2.1 2.1z m6.4-1.4c0.8-0.4 1.2-1.5 0.9-2.3-0.6 0.5-1.6 1.5-1.6 2.4 0 0.2 0.5 0 0.7-0.1z' })
        )
    );
};

exports.default = IoSocialSass;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/social-sass.js
// module id = 2468
// module chunks = 0